import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Text, Tabs } from '@teals/ui-web';
import type { TabItem } from '@teals/ui-web';
import { UsagePanel } from './UsagePanel';
import { BillingPanel } from './BillingPanel';
import { Page, Subtitle } from './Payments.styles';

type PaymentsTab = 'usage' | 'billing';

const Payments: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const tab = (params.get('tab') as PaymentsTab) || 'usage';

  const items: TabItem[] = useMemo(
    () => [
      { id: 'usage', label: 'Usage' },
      { id: 'billing', label: 'Billing' },
    ],
    [],
  );

  const onTabChange = (id: string) => {
    const next = new URLSearchParams(params);
    next.set('tab', id);
    setParams(next, { replace: true });
  };

  return (
    <Page>
      <div>
        <Text variant="h2">Payments</Text>
        <Subtitle>
          Organisation bill (subscription + usage) and billing settings. Token
          drivers live on Analytics.
        </Subtitle>
      </div>

      <Tabs items={items} activeTab={tab} onChange={onTabChange} />

      {tab === 'billing' ? <BillingPanel /> : <UsagePanel />}
    </Page>
  );
};

export default Payments;
